export default __webpack_public_path__ + "5c9236c247710bb591207f907bdb993f.svg";